import { atom } from "recoil";

export type PCSideTabType = "home" | "chat" | "mypage";
export const pcSideTabAtom = atom<PCSideTabType>({
  key: "pcSideTab",
  default: "home",
});

// '나' 탭에 속한 섹션 경로들(설정·결제내역·고객센터 등).
// 주의: prefix 매칭은 `=== p || startsWith(p + "/")` 이므로 "-update"·"-faq" 같은
// 하이픈 변형은 별도 항목으로 추가해야 한다(/notification-settings 가 -update 를 못 잡음).
export const MYPAGE_SECTION_PREFIXES = [
  "/mypage",
  "/account",
  "/payment-history",
  "/notification-settings",
  "/notification-settings-update",
  "/security-settings",
  "/pin-setup",
  "/unlock",
  "/support",
  "/support-faq",
  "/subscription-pause",
];

export function isMyPageSectionPath(pathname: string): boolean {
  return MYPAGE_SECTION_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(p + "/")
  );
}

// 현재 URL 이 어느 PC 탭에 속하는지 파생한다(하이라이트·레이아웃 판단용 단일 기준).
// atom 은 탭 클릭 시 네비게이션 트리거로만 쓰고, '활성 탭' 표시는 URL 에서 파생해
// "탭=나 인데 콘텐츠는 progress/payment-history" 같은 불일치를 구조적으로 차단한다.
export function pcTabFromPath(pathname: string): PCSideTabType {
  if (pathname === "/chat" || pathname.startsWith("/chat/")) return "chat";
  if (isMyPageSectionPath(pathname)) return "mypage";
  return "home";
}
